import { AbstractControl, UntypedFormControl, UntypedFormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import moment from 'moment';

const FORMAT_DATE = 'YYYY-MM-DD'

export class CustomValidators {
  static startDateMinimum(startDate: UntypedFormControl): ValidationErrors | null {
    if (!startDate.value) {
      return null;
    }

    const validDate = moment(startDate.value, FORMAT_DATE) >= moment(moment().format(FORMAT_DATE), FORMAT_DATE);
    return validDate ? null : { invalidStartDate: true };
  }

  static startDateAfterToday(startDate: UntypedFormControl): ValidationErrors | null {
    if (!startDate.value) {
      return null;
    }

    const validDate = moment(startDate.value, FORMAT_DATE) > moment(moment().format(FORMAT_DATE), FORMAT_DATE);
    return validDate ? null : { startAfterToday: true };
  }

  static endDateGreaterThanStartDate(): ValidatorFn {
    return (formGroup: UntypedFormGroup) => {
      const startDate = formGroup.get('startDate');
      const endDate = formGroup.get('endDate');

      if (!startDate || !endDate) { return null }

      const startDateValue = startDate.value;
      const endDateValue = endDate.value;

      if (!startDateValue || !endDateValue) { return null }

      if (moment(endDate.value, FORMAT_DATE) >= moment(startDate.value, FORMAT_DATE)) { return null }

      if (moment(endDate.value, FORMAT_DATE) < moment(startDate.value, FORMAT_DATE)) {
        return { invalidEndDate: true };
      }
      return null;
    }
  }
}


export const NO_WHITESPACE_VALIDATOR = (control: AbstractControl) =>
  (control.value || '').trim().length ? null : { whitespace: 'Insert valid input' };
